(() => {
  if (customElements.get('planet-placement')) {
    return;
  }

  class PlanetPlacement extends HTMLElement {
    constructor() {
      super();
      this.observer = new MutationObserver(this.handleMutations.bind(this));
    }

    connectedCallback() {
      this.observer.observe(document.body, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    handleMutations() {
      const planetContainer = document.querySelector('.shopify-planet-banner-v2-container');
      const planetSection = planetContainer ? planetContainer.closest('section') : null;

      if (!planetSection)
      return

      const planetBlock = planetSection.querySelector('.shopify-app-block');
      if (planetBlock) {
        this.appendChild(planetBlock);

        const button = this.querySelector('button.shopify-planet-open-popup');

        if (button) {
          button.textContent = 'Learn more';
        }

        this.observer.disconnect();
      }
    }
  }

  customElements.define('planet-placement', PlanetPlacement);
})();
